import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Details from "./../Organizations/Details";

const Organizations = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/leads/organizations" component={List} />
        <Route
          exact
          path="/admin/leads/organizations/:id"
          component={Details}
        />
      </Switch>
    </Router>
  );
};
export default Organizations;
